import React from "react";
import i18n from "../../../i18n";
import ReportGeneric from "../ReportGeneric";
import RGIndividual from "../ReportGenericIndividual";
import ReportAction from "../../../actions/ReportAction";
import { getCounFilterEmployees } from "../../../actions/OrganizationAction";
import { CounselingSupportGraph } from "../../../constants/supportGraph";
import CounselingChartList, { DrawCounselingGraph } from "../../../components/report/counseling/CounChartList";
import { counselingFilterToBread, counselingFilterToRequest } from "../../../util/report";

export const CounselingGeneric = (props)=><RGIndividual 
	{...props}
	header={i18n.t("counseling")}
	fetchDeep={ReportAction.fetchCounSelectByFilter}
	fetchIndividual={ReportAction.fetchCounIndividualByFilter}
	getExportPromise={ReportAction.exportCounFilterExcel}
	searchEmployee={getCounFilterEmployees}
	drawSingleGraph={DrawCounselingGraph}
	drawListGraph={CounselingChartList} 
	calculateDeepMax={(res)=>{
		/**
		 * Not working for mockup with PatientFeedback and ProviderFeedback
		 */
		let outDeep = Object.keys(res).length;
		if((res[CounselingSupportGraph.PatientFeedback] !== undefined) && 
			(res[CounselingSupportGraph.ProviderFeedback] !== undefined)){
			outDeep -= 1;
		}
		// console.log("outdeep of res ", res, " is ",outDeep,
		// 	" of total key ",Object.keys(res).length);
		return outDeep;
	}}
	filterToRequest={counselingFilterToRequest}
	filterToBread={counselingFilterToBread}
/>;



// WEBPACK FOOTER //
// ./src/containers/ReportPanels/Counseling/index.js